module.exports = __webpack_public_path__ + "static/img/avatar-women.52ad583f.png";